/*
 *  Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled, { css } from "styled-components";
import { theme } from "@nordcloud/gnui";

type Props = {
  selectable?: boolean;
};

const getSelectableCSS = () => css`
  cursor: pointer;

  &:hover {
    background: ${theme.color.background.ui04};

    * {
      text-decoration: none;
    }
  }
`;

export const List = styled.ul<Props>`
  list-style: none;

  > li {
    ${(props) => props.selectable && getSelectableCSS()}
  }
`;
